var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnect1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 99,
    viewBox: "0 0 98 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.341 39.6309L30.5308 58.5248",
    stroke: "#F0F6FA",
    strokeWidth: 3.01538,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6589 39.6309L67.4692 58.5248",
    stroke: "#F0F6FA",
    strokeWidth: 3.01538,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4359 69.1805H61.5641",
    stroke: "#F0F6FA",
    strokeWidth: 3.01538,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8718 81.7445C30.8108 81.7445 36.4359 76.1194 36.4359 69.1804C36.4359 62.2415 30.8108 56.6163 23.8718 56.6163C16.9329 56.6163 11.3077 62.2415 11.3077 69.1804C11.3077 76.1194 16.9329 81.7445 23.8718 81.7445Z",
    stroke: "#F0F6FA",
    strokeWidth: 3.01538,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1282 81.7445C81.0672 81.7445 86.6923 76.1194 86.6923 69.1804C86.6923 62.2415 81.0672 56.6163 74.1282 56.6163C67.1892 56.6163 61.5641 62.2415 61.5641 69.1804C61.5641 76.1194 67.1892 81.7445 74.1282 81.7445Z",
    stroke: "#F0F6FA",
    strokeWidth: 3.01538,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49 41.5394C55.939 41.5394 61.5641 35.9143 61.5641 28.9753C61.5641 22.0363 55.939 16.4112 49 16.4112C42.0611 16.4112 36.4359 22.0363 36.4359 28.9753C36.4359 35.9143 42.0611 41.5394 49 41.5394Z",
    stroke: "#F0F6FA",
    strokeWidth: 3.01538,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect1);
export default __webpack_public_path__ + "static/media/connect-1.b2707788e9b15147516fdeec0e8a196b.svg";
export { ForwardRef as ReactComponent };